import produce from "immer";

import types from "./types";

const INITIAL_STATE = {
  behavior: "create",
  components: {
    drawer: false,
    confirmDelete: false,
    view:"week"
  },
  vansReservadas:[],
  form: {
    filtering: false,
    disabled: true,
    saving: false,
  },
  colaboradores: [],
  servicos:[],
  horarios:[],
  id_extratime:{},
  vans_user:[],
  horario: [],
  users:{
    id:"",
    name:"",
    email:"",
    cpf:"",
    phone_number:"",
    address:"",
    address_number:"",
    address_complement:"",
    address_district:"",
    address_city:"",
    address_state:"",
    address_zipcode:"",
    password:"",
    active:false
  },
  users_licenses:{
    id:"",
    photo:"",
    number:"",
    valid_to:"",
    category:"",
    users_id:"",
    active:""
  }
};

function Vans(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.UPDATE_HORARIO_VANS: {
      return produce(state, (draft) => {
        draft = { ...draft, ...action.payload };
        return draft;
      });
    }
    case types.RESET_HORARIO_VANS: {
      return produce(state, (draft) => {
        draft.Vans = INITIAL_STATE.Vans;
        return draft;
      });
    }
   
    default:
      return state;
  }
}

export default Vans;
